import React, { useContext } from 'react';
import { List, ListItem, ListItemText, Typography, Avatar, ListItemAvatar, Box } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';

const ConversationList = ({ conversations, onSelectConversation }) => {
  const { userId } = useContext(AuthContext);

  const DEFAULT_AVATAR_FALLBACK = "https://via.placeholder.com/40x40.png?text=User";

  if (!conversations || conversations.length === 0) {
    return <Typography sx={{ p: 2, textAlign: 'center' }}>No conversations yet.</Typography>;
  }

  return (
    <Box sx={{
      height: '100%',          // Take full height of container
      overflowY: 'auto',       // Scroll if list is long
      bgcolor: 'background.paper',
    }}>
      <List sx={{ p: 0 }}>
        {conversations.map(conv => {
          const otherParticipant = conv.otherUser;

          let participantName = 'User';
          if (otherParticipant) {
            participantName = `${otherParticipant.firstName || ''} ${otherParticipant.lastName || ''}`.trim() || 'User';
          }

          const participantImage = otherParticipant?.imageURL || '';
          const listItemKey = `${conv.castingId}-${otherParticipant?.id || 'unknown'}`;

          return (
            <ListItem
              button
              key={listItemKey}
              onClick={() => onSelectConversation(conv)}
              sx={{
                px: 2,
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                '@media (max-width:600px)': {
                  px: 1,
                  py: 1,
                },
              }}
            >
              <ListItemAvatar>
                <Avatar
                  src={participantImage || DEFAULT_AVATAR_FALLBACK}
                  alt={participantName}
                  sx={{ width: 48, height: 48, '@media (max-width:600px)': { width: 40, height: 40 } }}
                >
                  {!participantImage && participantName[0]}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    noWrap
                    sx={{ fontWeight: 500 }}
                  >
                    {conv.castingTitle}
                  </Typography>
                }
                secondary={
                  <Typography noWrap variant="body2" color="textSecondary">
                    with {participantName}
                  </Typography>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default ConversationList;
